<template>
    <div :class="[$style.promo_list, props.position && $style[props.position]]">
        <LinkSwitcher
            v-for="{ location, title, id } in promoCategoriesList"
            :key="id"
            :class="$style.switcher"
            :title="title"
            :icon="id"
            :to="location"
            dataInterfaceTarget="search-promo-category"
        />
    </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'

import LinkSwitcher from '@/components_new/LinkSwitcher.vue'
import { useGeneralStore } from '@/store/general-store'

const generalStore = useGeneralStore()
const { promoCategoriesList } = storeToRefs(generalStore)

const props = defineProps<{
    position?: 'center'
}>()
</script>
<style module>
.switcher {
    padding: 6px 12px;
}
.promo_list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.center {
    justify-content: center;
    padding: 12px;
}

@media (--desktop-small-plus) {
    .promo_list {
        gap: 12px;
        padding: 0 12px;
    }
    .center {
        padding: 12px;
    }
}
</style>
